import { FormControlLabel as MuiFormControlLabel } from '@mui/material';
import { formControlLabelClasses, FormControlLabelProps } from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';

export type { FormControlLabelProps };

export const FormControlLabel: React.ComponentType<FormControlLabelProps> = styled(
  MuiFormControlLabel,
)<FormControlLabelProps>(() => ({
  [`&.${formControlLabelClasses.root}`]: {
    marginLeft: '0px',
    gap: '12px',
    alignItems: 'flex-start',
  },
}));
